import React from 'react';
import { Currency, DateTime } from '~/components';
import { BulkActionModal } from '~/components/bulk-action';
import { useApi, useWorkspace } from '~/contexts';

export default function BulkDelete({ projectId, ids, currency, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  const renderRow = ({ prepayment }) => (
    <>
      <DateTime value={prepayment.date} /> &middot; {prepayment.invoiceItem?.name} &middot;{' '}
      <Currency value={prepayment.fee} currency={currency} />
    </>
  );

  return (
    <BulkActionModal
      title="Delete Prepayments"
      variant="delete"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projectSettings(projectId)
          .prepayments()
          .bulkDelete(ids)
          .then((r) => r.data)
      }
      renderRow={renderRow}>
      {`This will delete ${
        ids.length === 1 ? 'the selected prepayment' : `the ${ids.length} selected prepayments`
      }. Prepayments that are on an invoice or have offset fees will be skipped. This action cannot be undone.`}
    </BulkActionModal>
  );
}
